class VisibilityTracker {
	constructor({
					threshold = 0.5,
					trackOnce = true,
					debounceTime = 100,
				} = {}) {
		this.threshold          = threshold;
		this.trackOnce          = trackOnce;
		this.debounceTime       = debounceTime;
		this.trackedElements    = new WeakMap();
		this.observer           = null;
		this.debounceTimeout    = null;
		this.pendingImpressions = new Set();

		this.initializeObserver();
	}

	initializeObserver() {
		this.observer = new IntersectionObserver(
			(entries) => this.handleIntersection(entries),
			{
				threshold: this.threshold,
			},
		);
	}

	handleIntersection(entries) {
		entries.forEach(entry => {
			const element = entry.target;
			const attributes  = element.dataset.attributes;

			if (!attributes) return;

			if (entry.isIntersecting) {
				if (this.trackOnce && this.trackedElements.get(element)) {
					return;
				}

				const stringify = JSON.parse(attributes);

				this.pendingImpressions.add(stringify);
				this.trackedElements.set(element, true);
			}
		});

		clearTimeout(this.debounceTimeout);
		this.debounceTimeout = setTimeout(() => {
			if (this.pendingImpressions.size > 0) {
				this.processImpressions();
			}
		}, this.debounceTime);
	}

	processImpressions() {
		if (!this.onImpression || this.pendingImpressions.size === 0) return;

		const impressions = Array.from(this.pendingImpressions);
		this.pendingImpressions.clear();

		this.onImpression(impressions);
	}

	observe(element) {
		if (!element) return;
		this.observer.observe(element);
	}

	unobserve(element) {
		if (!element) return;
		this.observer.unobserve(element);
	}

	disconnect() {
		this.observer.disconnect();
		this.trackedElements = new WeakMap();
		this.pendingImpressions.clear();
	}
}

export default VisibilityTracker;
